<template>
  <div>
    <AgregarBmat :generacionId="generacionId" v-if="generacionId" />

    <v-card>
      <v-card-title>
        <h2>BMAT</h2>
      </v-card-title>
      <v-card-text>
        <v-col cols="12">
          <GeneracionAutocomplete
            ref="asig"
            returnObject
            @generacionId="setGeneracionId"
          />
          <!-- :filtroEstado="['Pendiente', 'Cerrado']" -->
        </v-col>
        <v-data-table
          :headers="headers"
          :items="totales"
          dense
          hide-default-footer
          items-per-page="100"
          :loading="loading"
          no-data-text="Sin datos"
        >
          <template v-slot:[`item.cantidad`]="props">
            {{ props.item.cantidad | numberFormat }}
          </template>
          <template v-slot:[`item.segundos`]="props">
            {{ props.item.segundos | numberFormat }}
          </template>
          <template v-slot:[`item.controls`]="props">
            <v-btn
              :props="props"
              small
              class="btn btn-primary btn-sm"
              @click="descargarItem(props.item)"
              >Descargar
            </v-btn>
          </template>

          <template slot="body.append">
            <tr>
              <th></th>
              <th></th>
              <th class="text-right">{{ cantidad | numberFormat }}</th>
              <th class="text-right">{{ segundos | numberFormat }}</th>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="leer" :disabled="!generacionId">Leer</v-btn>
        <v-btn
          color="info"
          v-if="generacion && generacion.estado == 'Pendiente'"
          @click="aplicarMacheo"
          :disabled="!generacionId || totales.length == 0"
          >Aplicar Macheo</v-btn
        >
        <!-- <v-btn color="info" v-if="generacion && generacion.estado == 'Pendiente'" :disabled="!generacionId || totales.length == 0">Generar Macheo pediente</v-btn> -->
        <v-btn
          color="info"
          :disabled="!generacionId || totales.length == 0"
          @click="descargarResumenChannel(generacionId)"
          >Descargar ResumenChannel</v-btn
        >
        <div class="red--text">{{ errorMessage }}</div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import AgregarBmat from "@/components/bmat/AgregarBmat.vue";
import GeneracionAutocomplete from "@/components/shared/GeneracionAutocomplete.vue";
import numeral from "numeral";
import axios from "axios";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      headers: [
        { text: "Catalogo", value: "catalogo" },
        { text: "Rubro", value: "rubro" },
        { text: "Filas", value: "cantidad", align: "end" },
        { text: "Segundos", value: "segundos", align: "end" },
        { text: "Accion", value: "controls", align: "end", sortable: false },
      ],
      loading: false,
      generacion: null,
      generacionId: null,
      errorMessage: "",
      totales: [],
    };
  },
  methods: {
    leer() {
      this.loading = true;
      this.errorMessage = "";
      axios
        .get("/bmat/segundosCatalogo?generacionId=" + this.generacionId)
        .then((response) => {
          console.log(response);
          this.totales = response.data;
          this.loading = false;
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    aplicarMacheo() {
      this.loading = true;
      this.errorMessage = "";
      axios
        .post("/bmat/aplicarMacheo?generacionId=" + this.generacionId)
        .then((response) => {
          console.log(response);
          this.totales = [];
          this.leer();
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    setGeneracionId(gen) {
      this.generacion = gen;
      this.generacionId = gen.id;
      this.totales = [];
    },
    descargarItem(item) {
      this.loading = true;
      axios
        .get(
          `/bmat/descargarDetalle?generacionId=${this.generacionId}&catalogo=${item.catalogo}&rubro=${item.rubro}`
        )
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/excel",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    descargarResumenChannel(generacionId) {
      this.loading = true;
      axios
        .get(
          `/bmat/descargarResumenChannel?generacionId=${generacionId}`
        )
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/excel",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
  filters: {
    numberFormat(value) {
      if (isNaN(value)) {
        return;
      }
      if (!value) {
        return numeral(0).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
      if (value) {
        return numeral(+value).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
  computed: {
    cantidad() {
      return this.totales.reduce((t, c) => t + c.cantidad, 0);
    },
    segundos() {
      return this.totales.reduce((t, c) => t + +c.segundos, 0);
    },
  },
  components: {
    AgregarBmat,
    GeneracionAutocomplete,
  },
};
</script>